
class LastSearched extends HTMLElement {
  template; lasts; max; 
  static selectors = {
    template: '[data-template]',
    searchTemplate: '[data-last-search]',
  }

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.template = this.querySelector(LastSearched.selectors.template).innerHTML;
    this.lasts = Utils.getSearched();
    this.max = parseInt(this.dataset.max) || 3;
    this.max = this.max > this.lasts.length ? this.lasts.length : this.max;

    if(this.template && this.lasts.length > 0){
      this.renderTemplate();
    }

  }

  renderTemplate = () => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.template, 'text/html');
    const searchTemplate = doc.querySelector(LastSearched.selectors.searchTemplate).outerHTML;
    const parentElement = doc.querySelector(LastSearched.selectors.searchTemplate).parentElement;
    doc.querySelector(LastSearched.selectors.searchTemplate).remove();
    for(var i=0;i<this.max;i++){
      const search = this.lasts[i];
      var temp = searchTemplate;
      temp = temp.replaceAll('QUERYTERM', encodeURIComponent(search));
      temp = temp.replaceAll('TERM', search);
      parentElement.appendChild(new DOMParser().parseFromString(temp, 'text/html').body.firstChild);
    }
    this.innerHTML = doc.body.innerHTML;
  }
  
}
if (!window.customElements.get("last-searched")) {
  window.customElements.define("last-searched", LastSearched);
}